// extracted by extract-css-chunks-webpack-plugin
module.exports = {"main_div":"contact-us__main_div","text":"contact-us__text","text1":"contact-us__text1","text2":"contact-us__text2"};